export enum FetchMode {
	LAZY= 'lazy',
	PREVIEW= 'preview',
	EAGER= 'eager',
}